var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "text-bold" }, [
        _vm._v("\n    You CANNOT sell any content that is not yours.\n  ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Please don’t try. We will find it. It is breaking the law. You will get\n    kicked out of hte platform and might get sued by the creator.\n  "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "text-bold" }, [
        _vm._v(
          "\n    You CAN publish Fanart or Creative Commons content if you post it for\n    FREE.\n  "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Or make sure you have written permission from the creator. We may ask for\n    this proof.\n  "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "text-bold" }, [
        _vm._v(
          "\n    Please credit the creator is your are not the author.\n  "
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Be sure you understand what Creative Commons license applies to content\n    and follow these rules.\n  "
        )
      ]),
      _vm._v(" "),
      _c("v-button", { on: { click: _vm.goBack } }, [_vm._v("Back")])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [_vm._v("Content Title")]),
      _vm._v(" by "),
      _c("i", [_vm._v("Name of Creator")]),
      _vm._v(". For example, “\n    "),
      _c("i", [_vm._v("\n      Cute Cat\n    ")]),
      _vm._v("\n    by "),
      _c("i", [_vm._v("John Doe")]),
      _vm._v("”\n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }